export const userManagementTour = [
    {
        id: "user-management-welcome",
        target: '[data-tour="user-management-welcome"]',
        title: "Welcome to Paytrix User Management",
        content: "Welcome to User Management tour...",
        // disableBeacon: true,
        placement: "center",
        route: "/dashboard",
        // isFixed: true,
    },
    {
        id: "user-management",
        target: '[data-tour="user-management"]',
        title: "User Management",
        content:
            "Manage and monitor all users associated with your account. View user details, access status, and account permissions from one place.",
        // disableBeacon: true,
        placement: "right",
        route: "/dashboard",
        // isFixed: true,
    },
    {
        id: "search-users",
        target: '[data-tour="search-users"]',
        title: "Search Users",
        content:
            "Use the search bar to quickly find users by their name. This helps you locate and manage specific users efficiently.",
        placement: "bottom",
        route: "/usermanagement",
    },
    {
        id: "add-new-user",
        target: '[data-tour="add-new-user"]',
        title: "Add New User",
        content:
            "Click the Add User button to create a new user account. You can assign roles and provide controlled access to team members.",
        placement: "bottom",
        route: "/usermanagement",
    },
    {
        id: "export-users",
        target: '[data-tour="export-users"]',
        title: "Export Users",
        content:
            "Export the user list for reporting, auditing, or record-keeping purposes. The exported file contains user information available in the User Management module.",
        placement: "bottom",
        route: "/usermanagement",
    },
    {
        id: "user-list",
        target: '[data-tour="user-list"]',
        title: "User List",
        content:
            "View all users associated with your account. The list displays user email addresses, names, roles, account status, and available actions.",
        placement: "bottom",
        route: "/usermanagement",
    },
    {
        id: "user-status",
        target: '[data-tour="user-status"]',
        title: "User Status",
        content:
            "Enable or disable user access using the status toggle. This allows you to control whether a user can access the merchant portal.",
        placement: "bottom",
        // style: { minheight: "600px" ,background: "yellow", color: "black"},
        route: "/usermanagement",
    },
    {
        id: "update-user",
        target: '[data-tour="update-user"]',
        title: "Update User",
        content:
            "Click the edit icon to update user information, permissions, or account settings.",
        placement: "bottom",
        route: "/usermanagement",
    },
    {
        id: "view-user-details",
        target: '[data-tour="view-user-details"]',
        title: "View User Details",
        content:
            "Click the view icon to see detailed information about a user account and its configuration.",
        placement: "bottom",
        route: "/usermanagement",
    },
    {
        id: "youre-all-set",
        target: '[data-tour="youre-all-set"]',
        title: "🎉You're All Set!",
        content:
            "You've completed the User Management walkthrough. You can now create, manage, update, and monitor users within your merchant account.",
        placement: "center",
        route: "/usermanagement",
    },
];